import { productTypeToFilterId } from "@/lib/utils";
import type { FilterOptionLike } from "./deriveMarketplacesFromSessions";

/**
 * Derive unique product types from sessions with counts.
 * One function per file (single method per file).
 */
export function deriveProductTypesFromSessions(
  sessions: Array<{
    productType?: string | null;
    displayName?: string | null;
    needReviewFields?: number | null;
  }>,
): FilterOptionLike[] {
  const byId = new Map<
    string,
    { id: string; name: string; displayName: string; count: number }
  >();
  for (const s of sessions) {
    const id = productTypeToFilterId(s.productType ?? "");
    const existing = byId.get(id);
    const count = s.needReviewFields ?? 0;
    if (existing) existing.count += count;
    else {
      // name stays the raw productType (the identity used to match sessions);
      // displayName is the readable label the sidebar renders.
      const name = s.productType || id;
      byId.set(id, { id, name, displayName: s.displayName || name, count });
    }
  }
  return Array.from(byId.values());
}
